module.exports = __webpack_public_path__ + "static/img/fundibeq_premio.4097b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion-en/fundibeq_premio.jpg
// module id = +fWr
// module chunks = 0